// extracted by mini-css-extract-plugin
export default {"card":"components_card__D00lo","address_card":"components_address_card__B9GjZ","table_product_title":"components_table_product_title__fbH-k"};